<template>
  <el-card
    style="height: 99%; overflow: auto"
    class="box-card"
    :body-style="{ height: '85%' }"
  >
    <div slot="header" class="FCC">
      <div class="FC">
        <span class="CH_FontSty">进度节点</span>
      </div>
      <div class="FC" style="margin-right: 32px">
        <el-button type="primary" size="small" @click="InserNodeVisible = true"
          >添加节点</el-button
        >
      </div>
    </div>
    <div style="height: 97%; overflow: auto">
      <el-table
        stripe
        :header-cell-style="{
          background: '#EBEFF2',
          color: '#1E2134',
          fontWeight: 'bold',
        }"
        :data="tableData"
        style="width: 100%"
        ><el-table-column
          align="center"
          type="index"
          label="序号"
          width="80"
        ></el-table-column>
        <el-table-column
          prop="pgns03"
          align="center"
          label="节点名称"
          width="600"
        >
        </el-table-column>
        <el-table-column
          prop="pgns04"
          align="center"
          label="节点时间"
          width="700"
        >
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="small"
              @click="editProject(scope.row)"
              >编辑</el-button
            >
            <el-button type="danger" size="small" @click="delProject(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="float: right"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="pageIndex"
        :page-size="pageSize"
        layout="prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <!-- 添加进度节点 -->
    <el-dialog title="添加节点" :visible.sync="InserNodeVisible" width="30%">
      <el-form ref="Form" label-width="80px">
        <el-form-item label="节点名称">
          <el-input
            style="width: 400px"
            v-model="NodeName"
            placeholder="请输入节点名称"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="节点时间">
          <el-date-picker
            style="width: 400px"
            v-model="NodeTime"
            type="datetime"
            placeholder="选择节点时间"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="InserNodeVisible = false">取 消</el-button>
        <el-button type="primary" @click="InsertNodedeter()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 编辑进度节点 -->
    <el-dialog title="编辑节点" :visible.sync="EditNodeVisible" width="30%">
      <el-form ref="editFrom" :model="editFrom" label-width="80px">
        <el-form-item label="节点名称">
          <el-input
            style="width: 400px"
            v-model="editFrom.ENodeName"
            placeholder="请输入节点名称"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="节点时间">
          <el-date-picker
            style="width: 400px"
            v-model="editFrom.ENodeTime"
            type="datetime"
            placeholder="选择节点时间"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="EditNodeVisible = false">取 消</el-button>
        <el-button type="primary" @click="EditNodedeter('editFrom')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
import {
  GetProgressnodesetList,
  InsertProgressnodeset,
  UpdateProgressnodeset,
  DeleteProgressnodeset,
} from "@/setAxios";
import dayjs from "dayjs";
export default {
  data() {
    return {
      tableData: [],
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      InserNodeVisible: false,
      NodeName: "",
      NodeTime: "",
      EditNodeVisible: false,
      editFrom: {
        Eid: "",
        ENodeName: "",
        ENodeTime: "",
      },
    };
  },
  mounted() {},
  methods: {
    //获取列表数据
    getProNodeList() {
      let params = {
        seachword: "",
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        pid: this.$store.state.xid,
      };
      GetProgressnodesetList(params).then((res) => {
        res.Data.list.forEach((element) => {
          element.pgns04 = dayjs(element.pgns04).format("YYYY年MM月DD日");
        });
        this.tableData = res.Data.list;
        this.total = res.Data.total;
      });
    },
    //添加进度节点
    async InsertNodedeter() {
      if (this.NodeName == "" || this.NodeTime == "") {
        this.$message({
          type: "warning",
          message: "请完成选项!",
        });
        return;
      } else {
        let params = {
          pgns02: this.$store.state.xid,
          pgns03: this.NodeName,
          pgns04: this.NodeTime,
        };
        let res = await InsertProgressnodeset(params);
        if (res.Code) {
          this.$message({
            type: "success",
            message: "添加成功!",
          });
          this.getProNodeList();
          this.InserNodeVisible = false;
          this.NodeName = "";
          this.NodeTime = "";
        } else {
          this.$message({
            type: "error",
            message: "添加失败!",
          });
        }
      }
    },
    //删除进度节点
    delProject(row) {
      this.$confirm("确定删除该项?", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let params = {
            id: row.pgns01,
          };
          let res = await DeleteProgressnodeset(params);
          if (res.Code) {
            this.$message({
              type: "success",
              message: "移除成功!",
            });
            this.getProNodeList();
          } else {
            this.$message({
              type: "error",
              message: "移除失败!",
            });
            return;
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    //打开修改进度节点弹窗
    editProject(row) {
      this.EditNodeVisible = true;
      this.editFrom.Eid = row.pgns01;
      this.editFrom.ENodeName = row.pgns03;
      this.editFrom.ENodeTime = row.pgns04
        .replace("年", "/")
        .replace("月", "/")
        .replace("日", "");
    },
    //修改确定按钮
    EditNodedeter(editFrom) {
      this.$refs[editFrom].validate(async (v) => {
        if (v) {
          let params = {
            pgns01: this.editFrom.Eid,
            pgns03: this.editFrom.ENodeName,
            pgns04: this.editFrom.ENodeTime,
          };
          let res = await UpdateProgressnodeset(params);
          if (res.Code) {
            this.$message({
              type: "success",
              message: "编辑成功!",
            });
            this.getProNodeList();
            this.EditNodeVisible = false;
            this.editFrom = {
              Eid: "",
              ENodeName: "",
              ENodeTime: "",
            };
          } else {
            this.$message({
              type: "error",
              message: "编辑失败!",
            });
            return;
          }
        }
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getProNodeList();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getProNodeList();
    },
  },
  created() {
    this.getProNodeList();
  },
};
</script>

<style scoped lang="less">
/deep/.el-card__header {
  padding: 18px 0px;
}
/deep/.el-dialog {
  border-radius: 10px;
}
.timeChange {
  position: absolute;
  z-index: 2;
  width: 30vw;
  overflow: auto;
}
</style>
